import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: 'subscription-set-payment-error-dialog',
    template: require('./subscription-set-payment-error-dialog.component.html')
})
export class SubscriptionSetPaymentErrorDialogComponent {

    message: boolean;

    constructor(
        @Inject(MAT_DIALOG_DATA) data
    ) {  this.message = data.message; }

    reload(): void {
        location.reload();
    }
}